<script>
import { mapGetters, mapActions } from "vuex";

import genders from "../service/genders";
import AdminAppShowDetail from "./AdminAppShowDetail.vue";
import AdminAppShowPhoto from "./AdminAppShowPhoto.vue";
import AdminAppPaidShowItem from "~/src/components/AdminAppPaid2024ShowItem.vue";
import axios from 'axios'

export default {
  components: { AdminAppPaidShowItem, AdminAppShowDetail, AdminAppShowPhoto },
  data: () => ({
    genders,
    photo: null,

    isEditingArchive: false,
    canArxivAction: false,
  }),

  computed: {
    ...mapGetters("admin-contracts2024", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSuperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
  },

  
  async mounted() {
    this.canArxivAction = await this.hasRole('KONTRAKT_24_25', 'ARXIV');
  },

  methods: {
    ...mapActions("admin-contracts2024", ["INIT_BY_ID"]),
    ...mapActions("admin-contracts2024", ["PAID_APPLICATION"]),

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },

    getGender(id) {
      return this.genders.find((x) => x.id == id) || {};
    },

    async onRefreshPayments() {
      this.$store.dispatch("SET_LOADING", true);
      const id = this.$route.params.id;
      await this.INIT_BY_ID({ id });
      this.$store.dispatch("SET_LOADING", false);
    },

    
    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: {appPanel: panel, op}
        });
        return res.data === true;
      } catch {
        return false;
      }
    },
    
    async saveArchive() {
      try {
        await axios.put('/admin/contract2024/edit/archive', {
          id: this.application.id,
          archiveNumber: this.application.archiveNumber, 
          archiveDate: this.application.archiveDate
        });

        this.isEditingArchive = false;
      } catch (err) {
        console.error(err);
      }
    }
  },
};
</script>

<template>
  <div>
    <v-form @submit.prevent="() => false" ref="form" lazy-validation>
      <v-row>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('First name')"
              :text="application.firstName"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Last name')"
              :text="application.lastName"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Middle name')"
              :text="application.middleName"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Gender')"
              :text="getGender(application.gender)[`name-${$i18n.locale}`]"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Date of birth')"
              :text="application.birthDate"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Kurs')"
              :text="application.kurs"
            />
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <div>
              <div class="-title" v-text="$t('Country')" />
              <div class="-text" v-text="application.country.name" />
            </div>
            <div class="pt-4">
              <div class="-title" v-text="$t('Region')" />
              <div class="-text" v-text="application.region.name" />
            </div>
            <div class="pt-4">
              <div class="-title" v-text="$t('City / District')" />
              <div class="-text" v-text="application.city.name" />
            </div>

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Address')"
              :text="application.addressLine"
            />
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Citizenship')"
              :text="application.citizenship.name"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Nationality')"
              :text="application.nationality"
            />
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <admin-app-show-detail :title="$t('Photo')" />
          <admin-app-show-photo
            class="pt-2"
            v-if="application.photo"
            :url="$file(application.photo)"
          />
        </v-col>
      </v-row>

      <div class="pt-10" />
      <div class="text-center">
        <img src="@/assets/icons/devider.svg" alt="" />
      </div>
      <div class="pt-10" />

      <v-row>
        <v-col cols="12" md="3">
          <admin-app-show-detail :title="$t('Copy of the passport')" />
          <admin-app-show-photo
            class="pt-2"
            v-if="application.passportPhoto"
            :url="$file(application.passportPhoto)"
          />
          <br />
          <admin-app-show-photo
            class="pt-2"
            v-if="application.passportBackPhoto"
            :url="$file(application.passportBackPhoto)"
          />
        </v-col>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Passport series and number')"
              :text="application.passportNumber"
            />
            <br />
            <admin-app-show-detail
              :title="$t('jshir')"
              :text="application.pinflNumber"
            />
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Home phone number')"
              :text="application.homePhone"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Personal phone number')"
              :text="application.mobilePhone"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Father\'s phone number')"
              :text="application.fatherPhone || '—'"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Mother\'s phone number')"
              :text="application.motherPhone || '—'"
            />
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <div class="-data-wrap">
            <admin-app-show-detail :title="$t('Payments Info')" />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Contract Number')"
              :text="application.contractNumber"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Guruh kodi')"
              :text="application.groupCode"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Kontract summasi')"
              money :text="application.totalSumma"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Tolangan summasi')"
              money :text="application.totalPaidSumma"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Qoldiq')"
              money :text="application.totalOstatok"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Tolovlar ruyxati')"
            />
            <!--    <div
              v-for="(item, index) in application.paymentList"
              :key="index"
              class="-text"
              v-text="`${index + 1}. ${item.datePayment}-da ${item.paid} so'm`"
            />-->

            <admin-app-paid-show-item
              v-for="(item, index) in application.paymentList"
              @refresh="onRefreshPayments"
              :key="index"
              :item-data="item"
              :label="`${index + 1}. ${formatDate(item.datePayment)}-da ${
                item.paid
              } so'm${item.comment ? ' — ' + item.comment : ''}`"
            />

            <div v-if="!application.paymentList?.length">—</div>
          </div>
        </v-col>
      </v-row>

      <div class="pt-10" />
      <div class="text-center">
        <img src="@/assets/icons/devider.svg" alt="" />
      </div>
      <div class="pt-10" />
      <v-row>
        <v-col cols="12" md="4">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Disability status')"
              :text="application.disability.name || '—'"
            />

            <admin-app-show-detail
              class="pt-4"
              :title="$t('Disability note')"
              :text="application.disabilityNote || '—'"
            />
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div class="-data-wrap">
            <div>
              <admin-app-show-detail
                :title="$t('Graduated school / college / lyceum')"
                class="-title"
                :text="application.schoolName"
              />
            </div>

            <admin-app-show-detail
              class="pt-4"
              :title="$t('School type')"
              :text="application.schoolType.name"
            />
            <admin-app-show-detail
              class="pt-4"
              :title="$t('Year of graduation')"
              :text="application.graduationYear"
            />
            <div>
              <admin-app-show-detail
                class="pt-4"
                :title="$t('Diploma / Certificate number')"
                :text="application.highSchoolDiplomaNumber"
              />
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <div class="-data-wrap">
            <admin-app-show-detail
              v-model="application.reviews.highSchoolDiplomaPhoto"
              :title="$t('Copy of the Certificate / Diploma')"
            />
            <admin-app-show-photo
              class="pt-2"
              v-if="application.highSchoolDiplomaPhoto"
              :url="$file(application.highSchoolDiplomaPhoto)"
            />
          </div>
        </v-col>
      </v-row>

      <div class="pt-10" />
      <div class="text-center">
        <img src="@/assets/icons/devider.svg" alt="" />
      </div>
      <div class="pt-10" />

      <v-row>
        <v-col cols="12" md="4">
          <admin-app-show-detail
            v-model="application.reviews.foreignLanguageProficiencyPhoto"
            :title="$t('The result of the English language')"
          />
          <admin-app-show-photo
            class="pt-2"
            v-if="application.foreignLanguageProficiencyPhoto"
            :url="$file(application.foreignLanguageProficiencyPhoto)"
          />
          <div v-else>—</div>
        </v-col>

        <v-col cols="12" md="4">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Type')"
              :text="application.foreignLanguageProficiency.name || '—'"
            />
            <div
              v-if="
                application.foreignLanguageProficiency.id &&
                application.foreignLanguageProficiency.id == 6
              "
            >
              <admin-app-show-detail
                :title="$t('name_certificate')"
                class="pt-4"
                :text="application.certificateOther || '—'"
              />
            </div>

            <admin-app-show-detail
              :title="$t('Score')"
              class="pt-4"
              :text="application.score || '—'"
            />

            <admin-app-show-detail
              :title="$t('Certificate number')"
              class="pt-4"
              :text="application.certificateNumber || '—'"
            />
          </div>
        </v-col>

        <v-col cols="12" md="4">
          <div class="-data-wrap">

            <admin-app-show-detail
                :title="$t('Code of study')"
                class="pt-4"
                :text="(application?.facultyMvdir || '') + ' - ' + (application?.facultySchetType || 'GLOBAL')"
            />

            <admin-app-show-detail
              :title="$t('Field of study')"
              class="pt-4"
              :text="application.educationFaculty.name"
            />
            <admin-app-show-detail
              :title="$t('Type of education')"
              class="pt-4"
              :text="application.educationType.name"
            />
            <admin-app-show-detail
              :title="$t('Language of instruction')"
              class="pt-4"
              :text="application.educationLanguage.name"
            />
          </div>
        </v-col>
        <v-col cols="12" md="4" v-if="application.dtmScore">
          <div class="-data-wrap">
            <admin-app-show-detail :title="$t('DTM Test Paper Result')" />
            <admin-app-show-photo
              class="pt-2"
              v-if="application.dtmAbiturientPhoto"
              :url="$file(application.dtmAbiturientPhoto)"
            />
            <div v-else>—</div>
          </div>
        </v-col>
        <v-col cols="12" md="4" v-if="application.dtmScore">
          <div class="-data-wrap">
            <admin-app-show-detail
              :title="$t('Total score')"
              class="pt-4"
              :text="application.dtmScore"
            />
            <admin-app-show-detail
              :title="$t('Applicant ID number')"
              class="pt-4"
              :text="application.dtmAbiturientNumber"
            />
          </div>
        </v-col>

                <v-col v-if="canArxivAction" cols="12" md="6">
          <div>
            <!-- Display mode -->
            <div v-if="!isEditingArchive && application.archiveDate && application.archiveNumber" class="mt-1">
              <div class="text-subtitle-1" style="color: #333; font-weight: 500;">Arxiv maʼlumotlari</div>
              
              <div class="text-body-2 grey--text" style="margin-top: 15px;">
                <span style="color: black; margin-right: 15px; font-weight: 400; font-size: 14px;">Arxiv raqami:</span>
                <div style="margin-top: 4px;">
                  <span class="font-weight-medium black--text" style="font-size: 16px; ">{{ application.archiveNumber }}</span>
                  <v-btn @click="isEditingArchive = true;" x-small text color="primary" class="ml-1">
                    <v-icon x-small style="color: #444; font-size: 14px;">mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </div>

              <div class="text-body-2 grey--text display-flex align-center" style="margin-top: 15px;">
                <span style="color: black; margin-right: 15px; font-weight: 400; font-size: 14px;">Arxiv sanasi:</span>
                <div style="margin-top: 4px;">
                  <span class="font-weight-medium black--text" style="font-size: 16px;" >{{ application.archiveDate }}</span>
                  <v-btn @click="isEditingArchive = true;" x-small text color="primary" class="ml-1">
                    <v-icon x-small style="color: #444; font-size: 14px;">mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>

            <!-- Add new when no data -->
            <div v-if="!isEditingArchive && !application.archiveDate && !application.archiveNumber" class="arxiv-placeholder">
              <p class="arxiv-placeholder__title">Arxiv maʼlumotlari</p>
              <div class="arxiv-placeholder__box" @click="() => {isEditingArchive = true}">
                <v-icon class="arxiv-placeholder__icon">mdi-plus</v-icon>
              </div>
            </div>

            <!-- Inline edit for archive number -->
            <div v-if="isEditingArchive" class="mt-2" style="display: flex; flex-direction: column; gap: 10px; max-width: 400px;">
              <v-text-field
                v-model="application.archiveNumber"
                label="Arxiv raqami"
                outlined
                dense
                hide-details
                autofocus
              ></v-text-field>
              <v-text-field
                v-model="application.archiveDate"
                label="Arxiv sanasi"
                outlined
                dense
                hide-details
                autofocus
              ></v-text-field>

              <v-btn
                style="background-color: #00274c; color: white; align-self: flex-start; width: 100%;"
                
                @click="saveArchive"
                small
              >
                Saqlash
              </v-btn>
            </div>

          </div>
        </v-col>

      </v-row>
    </v-form>

    <!--    <app-confirm v-model="paidDialog" :text="$t('paid?')" @accept="onPaid" />-->
  </div>
</template>

<style lang="scss" scoped>
.-data-wrap {
  height: 100%;
  border-left: 1px solid rgba(128, 128, 128, 0.699);

  padding-left: 15px;
}

.-title {
  font-size: 14px;
}

.-text {
  font-weight: 500;
}

.arxiv-placeholder {
  &__title {
    font-weight: 500;
  }

  &__box {
    margin-top: 4px;
    color: #757575;
    cursor: pointer;
    border: 2px dashed #9e9e9e;
    border-radius: 6px;
    width: 350px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: border-color 0.2s ease;

    &:hover {
      border-color: #000;

      .arxiv-placeholder__icon {
        color: #0a0a0a;
      }
    }

    &:focus-visible {
      outline: 2px solid #1976d2;
      outline-offset: 2px;
    }
  }

  &__icon {
    color: #9e9e9e;
    margin-right: 4px;
    transition: color 0.2s ease;
    font-size: 24px;
  }
}
</style>
